// Meta Pixel loader. Mirrors the behavior of the previous inline script that
// lived in client/public/index.html so the SPA HTML can ship with zero inline
// <script> blocks (see docs/security/http-headers-audit.md).
//
// The module is side-effect-free at import time: nothing runs until the call
// site invokes initMetaPixel(). Deferral (requestIdleCallback / setTimeout) is
// the caller's responsibility.

export const META_PIXEL_ID = '721348697311217';

const FBEVENTS_SRC = 'https://connect.facebook.net/en_US/fbevents.js';

export function initMetaPixel(pixelId) {
  if (typeof window === 'undefined' || typeof document === 'undefined') return;

  try {
    if (
      window.localStorage &&
      window.localStorage.getItem('meta_pixel_opt_out') === 'true'
    ) {
      return;
    }
  } catch (e) {
    // localStorage access can throw in sandboxed iframes / Safari private mode.
    // Fall through to normal init.
  }

  if (window.fbq) return;

  const f = window;
  const b = document;
  const n = (f.fbq = function () {
    n.callMethod
      ? n.callMethod.apply(n, arguments)
      : n.queue.push(arguments);
  });
  if (!f._fbq) f._fbq = n;
  n.push = n;
  n.loaded = true;
  n.version = '2.0';
  n.queue = [];

  const t = b.createElement('script');
  t.async = true;
  t.src = FBEVENTS_SRC;
  const s = b.getElementsByTagName('script')[0];
  if (s && s.parentNode) {
    s.parentNode.insertBefore(t, s);
  } else {
    (b.head || b.documentElement).appendChild(t);
  }

  f.fbq('init', pixelId);
  f.fbq('track', 'PageView');
}
